var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7072 5.70711C13.0977 5.31658 13.0977 4.68342 12.7072 4.29289C12.3166 3.90237 11.6835 3.90237 11.2929 4.29289L4.29881 11.287C4.27574 11.3097 4.25377 11.3335 4.23298 11.3583C4.17922 11.4225 4.13476 11.4917 4.09961 11.5644C4.03579 11.6961 4 11.8439 4 12C4 12.1561 4.03579 12.3039 4.09961 12.4356C4.13473 12.5082 4.17914 12.5774 4.23284 12.6415C4.25368 12.6664 4.2757 12.6902 4.29882 12.713L11.2929 19.7071C11.6835 20.0976 12.3166 20.0976 12.7072 19.7071C13.0977 19.3166 13.0977 18.6834 12.7072 18.2929L7.41426 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H7.41426L12.7072 5.70711Z",
    fill: "#6D46DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.d00cf96e3d047e2bd9536b2e349e0a70.svg";
export { ForwardRef as ReactComponent };